module.exports = __webpack_public_path__ + "static/artworking-1-mobile-2fd22f6748289d65f71160db3e2d2c95.jpg";